import React from "react";

function site_logo()
{
    return (
        <div className="sitelogo " data-cursor-text=" " data-cursor="-inverse">
            <h1>RASHED</h1>
        </div>
    );
}

export default site_logo;